import {
  type ToggleTreatment,
  ToggleTreatments,
  useFeature,
} from 'src/abTesting';
import { AC_GLOBAL_FOOTER_REDESIGN } from 'src/abTesting/features';

export interface UseShowFooterRedesignReturnType {
  showFooterRedesign: boolean;
  treatment: ToggleTreatment;
}

export const useShowFooterRedesign = (): UseShowFooterRedesignReturnType => {
  const { treatment } = useFeature(AC_GLOBAL_FOOTER_REDESIGN);

  const showFooterRedesign = treatment === ToggleTreatments.on;

  return {
    showFooterRedesign,
    treatment,
  };
};
